import script from "./TagLinkButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagLinkButton.vue?vue&type=script&lang=ts&setup=true"

import "./TagLinkButton.vue?vue&type=style&index=0&id=c89c7b10&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c89c7b10"]])

export default __exports__